// extracted by mini-css-extract-plugin
export var legendIndicator = "_eo-1";
export var legendRight = "_eo-0";